import { configureStore } from '@reduxjs/toolkit';
import exampleReducer from '../features/auth/exampleSlice';
import authReducer from '../features/auth/authSlice';

const REFRESH_TOKEN_KEY = 'refreshToken';

const loadRefreshToken = (): string | null => {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

const saveRefreshToken = (token: string | null) => {
  try {
    if (token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  } catch (error) {
    // Ignore storage errors (e.g., privacy mode).
  }
};

const preloadedRefreshToken = loadRefreshToken();

export const store = configureStore({
  reducer: {
    example: exampleReducer,
    auth: authReducer,
  },
  preloadedState: {
    auth: {
      accessToken: null,
      refreshToken: preloadedRefreshToken,
      tokenType: 'Bearer',
      accessTokenExpiresIn: null,
      user: null,
    },
  },
});

let lastRefreshToken = preloadedRefreshToken;

store.subscribe(() => {
  const { refreshToken } = store.getState().auth;
  if (refreshToken !== lastRefreshToken) {
    lastRefreshToken = refreshToken;
    saveRefreshToken(refreshToken);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
